import Entity from './entity'

export default class MultiCategory extends Entity<number>{
    name: string;
    classTypeId: number;
    multiTypeName: string;
    parentId?: number;
    parentName: string;
    order: number;
    isCanAddChildi: boolean;
    children: [];
    maxSortNo:number;
    //是否不显示
    isNoShow: boolean;
    isShowSetting: boolean;
    isTypeSetting: boolean;
    description: string;
    //是否在课程管理显示
    isLearningShow: boolean;
}